import { Link, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { InfosAccordions } from "@features/home/common/InfosAccordions/InfosAccordions";
import { useStyle } from "./style";
import { WORDPRESS_URL } from "@constants";

export const HomeBroadbandFrequentlyAskedQuestions = () => {
    const { classes } = useStyle();
    const { t } = useTranslation("home", { keyPrefix: "broadbandFaqHome" });

    return (
        <section className={classes.section}>
            <Typography className={classes.sectionTitle} variant="h2">
                {t("title")}
            </Typography>
            <div className={classes.accordionsWrapper}>
                <InfosAccordions title={t("switchFromProvider.title")}>
                    <div className={classes.paragraphs}>
                        <Typography variant="normal">{t("switchFromProvider.para1")}</Typography>
                        <Typography variant="normal">
                            <Trans
                                components={[
                                    <Link
                                        href={`${WORDPRESS_URL}/cancel-previous-broadband`}
                                        key="cancel-previous-broadband-link"
                                        rel="noreferrer"
                                        target="_blank"
                                    />,
                                ]}
                                i18nKey="broadbandFaqHome.switchFromProvider.para2"
                                ns="home"
                            />
                        </Typography>
                    </div>
                </InfosAccordions>
                <InfosAccordions title={t("speed.title")}>
                    <div className={classes.paragraphs}>
                        <Typography variant="normal">{t("speed.content")}</Typography>
                    </div>
                </InfosAccordions>
                <InfosAccordions title={t("contract.title")}>
                    <div className={classes.paragraphs}>
                        <Typography color="secondary" variant="normal">
                            {t("contract.para1")}
                        </Typography>
                        <Typography variant="normal">{t("contract.para2")}</Typography>
                    </div>
                </InfosAccordions>
                <InfosAccordions title={t("install.title")}>
                    <div className={classes.paragraphs}>
                        <Typography variant="normal">{t("install.para1")}</Typography>
                        <Typography variant="normal">{t("install.para2")}</Typography>
                        <Typography variant="normal">{t("install.para3")}</Typography>
                        <Typography variant="normal">{t("install.para4")}</Typography>
                    </div>
                </InfosAccordions>
                <InfosAccordions title={t("wifiBoost.title")}>
                    <div className={classes.paragraphs}>
                        <Typography variant="normal">{t("wifiBoost.para1")}</Typography>
                        <Typography variant="normal">{t("wifiBoost.para2")}</Typography>
                    </div>
                </InfosAccordions>
            </div>
        </section>
    );
};
